export const MEXICO_TIMEZONE = 'America/Mexico_City';
export const SYSTEM_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;
